import axios from "axios";

import { apiConfig } from "src/config";

const axiosInt = axios.create();

axiosInt.defaults.baseURL = apiConfig.api_url;

axiosInt.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "There is an error!",
    ),
);

export default axiosInt;
